import { render, staticRenderFns } from "./UniformConfigInfo.vue?vue&type=template&id=1af52cb0&"
import script from "./UniformConfigInfo.vue?vue&type=script&lang=js&"
export * from "./UniformConfigInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports